import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({providedIn: 'root'})
export class SecretService {
    public get adalConfig(): any {
        return {
            tenant: 'viacom.onmicrosoft.com',
            clientId: environment.ADKey,
            redirectUri: window.location.origin + '/',
            postLogoutRedirectUri: window.location.origin + '/'
        };
    }
}
